<form [formGroup]="selectForm">
    @if(!loading){
    <div class="flex-column p-2">
        <div class="flex-row align-center-center pbs-1" style="border-bottom:1px solid rgba(189, 177, 213, 1)">
            <span></span>

            <!-- TITLE TAG -->
            <span class="flex-90 subtitle-4 mxs-1" style="line-height: inherit;">
            @if(modePatients){
                Pacientes
            }@else{
                Listado de Prestadores
            }
            </span>

            <mat-icon class="flex-1-1-auto cursor-pointer" [color]="'primary'" (click)="toggleList()">
                {{listVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
            </mat-icon>
        </div>


        <div class="pts-3" [@collapse]="listVisible ? 'expanded' : 'collapsed'">
            @if(displayedMarkers.length > 0 || this.selectForm.get(this.SEARCH)!.value.length > 0){

            <div class="flex-row mbs-1">
            <!-- MASTER CHECKBOX -->
                <mat-checkbox
                    [checked]="isAllVisible()"
                    [indeterminate]="isSomeVisible() && !isAllVisible()"
                    (change)="toggleAllHeader($event.checked)"
                    color="primary">
                </mat-checkbox>
             <!-- SEARCH BAR -->
                <mat-form-field class="flex full-width" appearance="outline" style="height: 10px !important;">
                    <input matInput [formControlName]="SEARCH" type="text" #searchInput
                        placeholder="{{modePatients? 'Buscar paciente por nombre o apellido' : 'Buscar prestador por nombre o apellido' }}"
                     />
                </mat-form-field>
            </div>
            <!-- LIST TABLE -->
            <table multiTemplateDataRows class="flex-100" mat-table [dataSource]="activeSearch ? matchedMarkers : displayedMarkers">
                <!-- selected -->
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let data">
                        <mat-checkbox
                            [checked]="!!data.visible"
                            (change)="onToggleMarker(data, $event.checked)"
                            color="primary">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <!-- name -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let data" class="">
                        <span class="marker-name">{{ data.name }}</span>
                    </td>
                </ng-container>

                <!-- state -->
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let data">
                        @if(!!data?.status) {
                        <div class="flex-column align-center-center mls-1">
                            <span class="state-chip marker-tag"
                                [ngStyle]="{color: PROVIDERS_STATUS_COLORS[data.status],
                                'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS[data.status]
                                }">
                                {{ providerStatusTags[data.status] | uppercase }}
                            </span>
                        </div>
                        }
                    </td>
                </ng-container>

                <!-- location -->
                <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef>Ubicación</th>
                    <td mat-cell *matCellDef="let data">
                        <mat-icon (click)="onClickLocation(data)" class="cursor-pointer mls-3" [style.width.px]="24"
                            [style.height.px]="24" [svgIcon]="IconMapMarkers[data.type]">
                        </mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="hide-header"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    class="bg-on-hover example-element-row">
                </tr>
            </table>
            }@else if(typeMarkers() === 'PROVIDERS'){
            <div class="flex-column align-center-center">
                <span class="subtitle-3">No hay prestadores disponibles</span>
                <span class="subtitle-5 body-2 mbs-3">No se encontraron prestadores que coincidan con esta especialidad></span>
            </div>
            }@else if (typeMarkers() === 'PATIENTS') {
            <div class="flex-column align-center-center ">
                <span class="subtitle-3">No hay pacientes disponibles</span>
                <span class="subtitle-5 body-2 mbs-3">No se encontraron pacientes para este prestador</span>
            </div>
        }
        </div>
    </div>
    }@else{
    <div class="flex-column align-center-center p-5">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    }
</form>
